'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ValidationError = exports.InvalidResponseCode = exports.NetworkError = exports.BaseResourceError = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeChecks = require('./typeChecks');

var _util = require('./util');

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BaseResourceError = exports.BaseResourceError = function () {
    function BaseResourceError(message) {
        _classCallCheck(this, BaseResourceError);

        this._message = message;
    }

    _createClass(BaseResourceError, [{
        key: 'toString',
        value: function toString() {
            return this._message;
        }
    }, {
        key: 'isNetworkError',
        get: function get() {
            // eslint-disable-line class-methods-use-this
            return false;
        }
    }, {
        key: 'isInvalidResponseCode',
        get: function get() {
            // eslint-disable-line class-methods-use-this
            return false;
        }
    }, {
        key: 'isValidationError',
        get: function get() {
            // eslint-disable-line class-methods-use-this
            return false;
        }
    }]);

    return BaseResourceError;
}();

var NetworkError = exports.NetworkError = function (_BaseResourceError) {
    _inherits(NetworkError, _BaseResourceError);

    function NetworkError(error) {
        _classCallCheck(this, NetworkError);

        var _this = _possibleConstructorReturn(this, (NetworkError.__proto__ || Object.getPrototypeOf(NetworkError)).call(this, 'NetworkError'));

        _this.error = error;
        return _this;
    }

    _createClass(NetworkError, [{
        key: 'isNetworkError',
        get: function get() {
            // eslint-disable-line class-methods-use-this
            return true;
        }
    }]);

    return NetworkError;
}(BaseResourceError);

var InvalidResponseCode = exports.InvalidResponseCode = function (_BaseResourceError2) {
    _inherits(InvalidResponseCode, _BaseResourceError2);

    function InvalidResponseCode(statusCode, responseText) {
        var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'InvalidResponseCode';

        _classCallCheck(this, InvalidResponseCode);

        var _this2 = _possibleConstructorReturn(this, (InvalidResponseCode.__proto__ || Object.getPrototypeOf(InvalidResponseCode)).call(this, type + ' ' + statusCode + ': ' + (0, _util.truncate)(responseText, 256)));

        _this2.statusCode = statusCode;
        _this2.responseText = responseText;
        return _this2;
    }

    _createClass(InvalidResponseCode, [{
        key: 'isInvalidResponseCode',
        get: function get() {
            // eslint-disable-line class-methods-use-this
            return true;
        }
    }]);

    return InvalidResponseCode;
}(BaseResourceError);

var ValidationError = exports.ValidationError = function (_InvalidResponseCode) {
    _inherits(ValidationError, _InvalidResponseCode);

    function ValidationError(err) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var isPrepared = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        _classCallCheck(this, ValidationError);

        if (isPrepared) {
            err = {
                responseText: err
            };
        }

        err = _extends({
            statusCode: 0,
            responseText: ''
        }, err);

        var _this3 = _possibleConstructorReturn(this, (ValidationError.__proto__ || Object.getPrototypeOf(ValidationError)).call(this, err.statusCode, err.responseText, 'ValidationError'));

        _this3._customOptions = options || {};
        _this3.errors = {};
        _this3.nonFieldErrors = null;

        _this3.__parseErrors(err.responseText);
        return _this3;
    }

    _createClass(ValidationError, [{
        key: 'getError',
        value: function getError(fieldName, allowNonFields) {
            if (this.errors[fieldName] || allowNonFields && this.nonFieldErrors) {
                return this.errors[fieldName] || this.nonFieldErrors || null;
            }

            return null;
        }

        /**
         * @deprecated Will be removed in the future
         */

    }, {
        key: 'getFieldError',
        value: function getFieldError(fieldName, allowNonField) {
            return this.getError(fieldName, allowNonField);
        }
    }, {
        key: 'firstError',
        value: function firstError(allowNonField) {
            if (allowNonField && this.nonFieldErrors) {
                return this.nonFieldErrors;
            }

            var errs = Object.keys(this.errors);

            if (errs.length > 0) {
                return this.errors[errs[0]];
            }

            return null;
        }
    }, {
        key: '__prepareError',
        value: function __prepareError(err) {
            return ((this._customOptions ? this._customOptions.prepareError : null) || ValidationError.defaultPrepareError)(err, this);
        }
    }, {
        key: '__parseErrors',
        value: function __parseErrors(errorText) {
            var handler = (this._customOptions ? this._customOptions.parseErrors : null) || ValidationError.defaultParseErrors;
            var result = handler(errorText, this);

            this.nonFieldErrors = result[0];
            this.errors = result[1];
        }
    }, {
        key: 'isValidationError',
        get: function get() {
            // eslint-disable-line class-methods-use-this
            return true;
        }
    }, {
        key: 'isInvalidResponseCode',
        get: function get() {
            // eslint-disable-line class-methods-use-this
            return false;
        }
    }], [{
        key: 'defaultParseErrors',
        value: function defaultParseErrors(errorText, instance) {
            if ((0, _typeChecks.isString)(errorText)) {
                if (errorText) {
                    errorText = JSON.parse(errorText);
                } else {
                    errorText = {};
                }
            }

            var resNonField = null;
            var resErrors = {};

            var errors = typeof errorText.errors === 'undefined' ? errorText : errorText.errors;
            Object.keys(errors).forEach(function (key) {
                if (key === 'non_field_errors') {
                    resNonField = instance.__prepareError(errors[key]);
                } else {
                    resErrors[key] = instance.__prepareError(errors[key]);
                }
            });

            return [resNonField, resErrors];
        }
    }, {
        key: 'defaultPrepareError',
        value: function defaultPrepareError(err, instance) {
            if ((0, _typeChecks.isString)(err)) {
                return err;
            } else if ((0, _typeChecks.isArray)(err)) {
                return err.join(', ');
            } else if ((0, _typeChecks.isObject)(err)) {
                // Note: We clone the object just in case
                return new ValidationError(Object.assign({}, err), instance ? instance._customOptions : null, true);
            } else {
                return '' + err;
            }
        }
    }]);

    return ValidationError;
}(InvalidResponseCode);


//////////////////
// WEBPACK FOOTER
// ../~/tg-resources/dist/errors.js
// module id = 195
// module chunks = 0